import styled from 'styled-components';

// Resumo do design Operacional.html — 4 KPIs em UMA caixa bordered
// hairline com colunas separadas por border-right interno.
// .kpi.pot .v -> red, .kpi.hist .v -> ink, .kpi.dia .v -> green,
// .kpi.upd .v -> JetBrains Mono.
export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--cco-line);
  border-radius: 14px;
  overflow: hidden;

  @media (max-width: 1400px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

// Card de KPI individual — padding 14/18 + border-right interno.
// last-child sem border-right (handles cleanly em 4-col).
export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 9px 14px;
  box-sizing: border-box;
  min-width: 0;
  border-right: 1px solid var(--cco-line);

  :last-child {
    border-right: 0;
  }

  @media (max-width: 1400px) {
    :nth-child(2n) {
      border-right: 0;
    }
    :nth-child(-n + 2) {
      border-bottom: 1px solid var(--cco-line);
    }
  }
`;

// Label — tipografia:
//   $title (uppercase 10.5px weight 600 letter-spacing 0.14em mute)
//   $value (22px weight 700 letter-spacing -0.01em tabular)
//   $unit (13px mute weight 500)
//   $mono (JetBrains Mono pra timestamps)
export const Label = styled.label`
  font-size: ${(props) =>
    props.$title ? '10px' : props.$mono ? '15px' : '18px'};
  font-weight: ${(props) => (props.$title ? 600 : 700)};
  text-transform: ${(props) => (props.$title ? 'uppercase' : 'none')};
  letter-spacing: ${(props) =>
    props.$title ? '0.14em' : props.$value ? '-0.01em' : '0'};
  line-height: 1.1;
  color: ${(props) =>
    props.$color
      ? props.$color
      : props.$title
      ? 'var(--cco-ink-mute)'
      : 'var(--cco-ink)'};
  font-variant-numeric: tabular-nums;
  font-family: ${(props) =>
    props.$mono
      ? "'JetBrains Mono', 'Courier New', monospace"
      : 'inherit'};
  white-space: nowrap;

  /* unit inline (small span dentro do value) */
  .u {
    font-size: 13px;
    color: var(--cco-ink-mute);
    font-weight: 500;
    margin-left: 5px;
  }
`;
